'use strict';

angular.module('TurneroApp').service('unidadService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Unidad/:id', { id: '@Id_Unidad' }, {
        get: {
            method: 'GET',
            params: {
                texto: '@texto'
            },
            url: portal.getUrlServer() + 'api/Unidad/',
            headers: portal.getHeadersServer(),
            isArray: true
        },
        getById: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Unidad/GetId/',
            headers: portal.getHeadersServer()
        },
        getUnidadCmb: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Unidad/Get_Unidades_Combo',
            headers: portal.getHeadersServer()
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/general/unidad-service.js